import { useEffect, useState } from 'react'
import * as React from 'react'
import cx from 'classnames'
import { throttle } from 'lodash'

import Styles from './ScrollHints.module.scss'
import { TopTiers } from './Types'

interface ScrollHintProps {
  scrollRef: React.RefObject<HTMLDivElement>
  topTier?: TopTiers
}

interface ScrollHintState {
  showLeft: boolean
  showRight: boolean
}

export const ScrollHintLeft = ({ scrollRef, topTier }: ScrollHintProps) => {
  const [{ showLeft: showLeftScrollHint }, setScrolHint] = useState<ScrollHintState>({
    showLeft: false,
    showRight: false,
  })
  useEffect(() => scrollHintEffect(scrollRef, setScrolHint), [scrollRef, topTier])
  return (
    <span
      className={cx(Styles.scrollHint, Styles.scrollHintLeft, {
        [Styles.scrollHintVisible]: showLeftScrollHint,
      })}
    ></span>
  )
}

export const ScrollHintRight = ({ scrollRef, topTier }: ScrollHintProps) => {
  const [{ showRight: showRightScrollHint }, setScrolHint] = useState<ScrollHintState>({
    showLeft: false,
    showRight: false,
  })
  useEffect(() => scrollHintEffect(scrollRef, setScrolHint), [scrollRef, topTier])
  return (
    <span
      className={cx(Styles.scrollHint, Styles.scrollHintRight, {
        [Styles.scrollHintVisible]: showRightScrollHint,
      })}
    ></span>
  )
}

function getScrollHint(scrollingElement: HTMLElement): { showLeft: boolean; showRight: boolean } {
  return {
    showLeft: scrollingElement.scrollLeft > 0,
    showRight: scrollingElement.scrollWidth > scrollingElement.offsetWidth + scrollingElement.scrollLeft,
  }
}

function scrollHintEffect(scrollRef: React.RefObject<HTMLDivElement>, setScrolHint: (state: ScrollHintState) => void) {
  if (!scrollRef.current) return

  setScrolHint(getScrollHint(scrollRef.current))
  const target = scrollRef.current
  const onScroll = throttle(() => setScrolHint(getScrollHint(target)), 100, { leading: true, trailing: true })
  target.addEventListener('scroll', onScroll)
  return () => {
    target.removeEventListener('scroll', onScroll)
  }
}
